export default __webpack_public_path__ + "static/media/caribeno-interviews-poster.439a9823.png";